// @flow
import React from 'react'
import ChannelsConfig from './channels-config'
import ChartConfig from './chart-config/chart-config'
import styled from 'styled-components'
import _ from 'lodash'
import TabSelector from 'plugin-assets/shared/widget/components/tab-selector'

type State = {
    tab: ChannelsWidgetConfigTabSelectorOptions
}
type Props = ChannelsValueTypeActionProps & {
    changeLayoutConfig?: (string, any) => void,
    type: string,
    dark?: boolean,
    lockAssetSelector?: boolean
}

export default class Configs extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            tab: 'channels'
        }
    }

    onChangeTab = (tab: ChannelsWidgetConfigTabSelectorOptions) => this.setState({ tab })

    render() {
        const channels = [
            ..._.get(this.props, 'widgetConfig.assets[0].channels', []),
            ..._.get(this.props, 'widgetConfig.assets[0].calculatedChannels', [])
        ]
        const chartOptionsDisabled = !(_.get(this.props, 'widgetConfig.assets[0].asset', false) && channels.length)

        return (
            <Theme>
                <TabSelector
                    value={this.state.tab}
                    onChange={this.onChangeTab}
                    chartOptionsDisabled={chartOptionsDisabled}
                />

                <ChannelsConfig
                    hidden={this.state.tab !== 'channels'}
                    widgetConfig={this.props.widgetConfig}
                    changeConfig={this.props.changeConfig}
                    changeLayoutConfig={this.props.changeLayoutConfig}
                    savedData={this.props.widgetConfig.assets || []}
                    hideAssetOnViewModeToggler={this.props.hideAssetOnViewModeToggler}
                    isEditor={this.props.isEditor}
                    hideLookupToggler={this.props.hideLookupToggler}
                    colorPickerPosition={this.props.colorPickerPosition}
                />

                <ChartConfig dark={!this.props.isEditor} hidden={this.state.tab === 'channels'} {...this.props} />
            </Theme>
        )
    }
}

export const Theme = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    max-height: 100%;
    .slider-input {
        width: 210px;
    }
`
